import React, { useEffect, useState } from 'react';
import { HubConnectionBuilder, HttpTransportType } from '@microsoft/signalr';

import { useLogin } from './LoginContext';
import { useGeneral } from '../../Context/GeneralContext';
import ActionToast from '../../components/ActionToast/ActionToast';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import '../../styles/login.css';
import imgTB from '../../img/loginTB.jpg';
import imgVaisand from '../../img/loginVaisand.jpg';
import config_img from '../../img/config.png';
import LogoTSR from '../../logos/LogoTSR.svg';
import LogoTBB from '../../logos/LogoTBB.svg';
import LogoMTB from '../../logos/LogoMTB.png';
import LogoNova from '../../logos/LogoNova.svg';
import LogoCol from '../../logos/LogoCol.svg';
import LogoPos from '../../logos/logoPosR.png';
import LogoVaisand from '../../logos/LogoVaisand.svg';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import { grey } from '@material-ui/core/colors';
import { User, Menu2, Logout } from 'tabler-icons-react';
import Input from '@material-ui/core/Input';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Button from '@material-ui/core/Button';
import { CircularProgress, FormHelperText, makeStyles } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import Config from './Config';
import Collapse from '@material-ui/core/Collapse';
import CloseIcon from '@material-ui/icons/Close';
import Cookies from 'universal-cookie';

let loginImg = imgTB;
if (process.env.REACT_APP_THEME === 'vaisandTheme') loginImg = imgVaisand;

// Determina si la respuesta del backend al login por tarjeta es un objeto de
// usuario válido. Cualquier otra cosa —un string, un mensaje "Error: ...", o un
// objeto sin token/usuario— se interpreta como tarjeta no reconocida.
const isValidLoginResponse = (resp) =>
    resp != null && typeof resp === 'object' && Boolean(resp.token) && Boolean(resp.usuario);

let logo,
    flag = false;
let color = '';

if (process.env.REACT_APP_THEME === 'tecnoTheme') {
    logo = LogoTBB;
    flag = true;
    color = '#eb7d1e';
} else if (process.env.REACT_APP_THEME === 'colTheme') {
    logo = LogoCol;
    flag = true;
    color = '#58ab01';
} else if (process.env.REACT_APP_THEME === 'matteTheme') {
    logo = LogoMTB;
    flag = true;
    color = '#3f4a51';
} else if (process.env.REACT_APP_THEME === 'posTheme') {
    logo = LogoPos;
    flag = true;
    color = '#00638D';
} else if (process.env.REACT_APP_THEME === 'vaisandTheme') {
    logo = LogoVaisand;
    flag = true;
    color = '#001F66';
} else {
    logo = '';
    flag = false;
    color = '#4c2e7f';
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '40%',
        marginLeft: '0%',
        position: 'absolute',
        fontFamily: 'WorkSans',
        fontSize: '23px',
        fontWeight: 'bold',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
    buttonSuccess: {
        width: '100%',
        backgroundColor: grey[500],
        '&:hover': {
            backgroundColor: grey[700],
        },
    },
    buttonProgress: {
        width: '100%',
        color: color[500],
        position: 'absolute',
        top: '52%',
        left: '43%',
        marginTop: -20,
        marginLeft: -12,
    },
}));

export default function Login({ setToken }) {
    const [tokenC, setTokenC] = useState([]);
    const [nombreL, setNombreL] = useState('');
    const [nombreC, setNombreC] = useState('');

    const classes = useStyles();
    const {
        handleUserName,
        handlePassChange,
        configView,
        isConfig,
        errorU,
        errorC,
        errorV,
        setIsConfig,
        handleClickShowPassword,
        values,
        usuario,
        password,
        setErrorU,
        setErrorC,
        LoginUser,
        setErrorV,
        getUsuario,
        infoUser,
        setConfigView,
        setTokenL,
        openA,
        setOpenA,
        openB,
        setOpenB,
        openC,
        setOpenC,
        openW,
        setOpenW,
        loading,
        setLoading,
    } = useLogin();

    const { openSnack, setOpenSnack, mensaje, tipoMensaje, setMensaje, setTipoMensaje } =
        useGeneral();

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const buttonClassname = clsx({
        [classes.buttonSuccess]: loading,
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const cookie = new Cookies();
        setOpenA(false);
        setOpenB(false);
        setOpenC(false);
        setOpenW(false);

        if (usuario.length === 0 && password.length === 0) {
            setErrorU(true);
            setErrorC(true);
            setLoading(false);
        } else if (usuario.length === 0) {
            setErrorU(true);
            setLoading(false);
        } else if (password.length === 0) {
            setErrorC(true);
            setLoading(false);
        } else {
            setErrorU(false);
            setErrorC(false);
            const token = await LoginUser({
                usuario,
                password,
            });
            if (token) {
                if (isConfig === false) {
                    if (cookie.get('login')) {
                        setLoading(false);
                        setToken(token);
                        getUsuario(usuario, token.token);
                    } else {
                        setOpenW(true);
                        setLoading(false);
                    }
                } else {
                    setTokenC(token);
                    getUsuario(usuario, token.token);
                    setLoading(false);
                }
            } else {
                setErrorV(true);
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        if (infoUser.length !== 0) {
            const isAdmin = infoUser.roles?.some((rol) => rol === 'Administrador');
    
            if (isAdmin && tokenC.length !== 0) {
                setConfigView(true);
                setTokenL(tokenC);
                setOpenC(false);
                setOpenA(false);
                setOpenB(false);
            } else {
                setOpenC(true);
            }
        }
    }, [infoUser, tokenC, setConfigView, setTokenL, setOpenA, setOpenB, setOpenC]);
    

    useEffect(() => {
        const cookie = new Cookies();
        if (cookie.get('nombreL') == null || cookie.get('nombreL') === undefined) {
            setNombreL('Configurar estación');
        } else {
            setNombreL(cookie.get('nombreL'));
        }

        const nombreCelda = cookie.get('nombreCelda');
        if (nombreCelda == null || nombreCelda === undefined || nombreCelda === '') {
            setNombreC('Debe configurar la estación');
        } else {
            setNombreC(nombreCelda);
        }
    }, [configView]);

    // Hub RFID: escucha el resultado de la lectura de tarjeta y hace login automático.
    // Solo activo si la estación tiene habilitada la autenticación por tarjeta (cookie 'card').
    // El backend requiere el id de celda como query param en la URL del hub.
    useEffect(() => {
        const cookie = new Cookies();
        if (cookie.get('card') !== 'true') return;

        const celdaId = parseInt(cookie.get('celda'));
        if (!celdaId) return;

        if (process.env.REACT_APP_ALLOW_WEBSOCKETS === 'false') return;

        const apiBase = process.env.REACT_APP_SERVICE_ENDPOINT_NE || '';
        const hubUrl = apiBase.replace('/api', '/HubNovaEngine');
        if (!hubUrl) return;

        // Login se desmonta al autenticar (setToken). Evita actualizar estado del
        // árbol Login desde un evento en vuelo tras el desmontaje.
        let cancelled = false;

        const connection = new HubConnectionBuilder()
            .withUrl(hubUrl, { skipNegotiation: true, transport: HttpTransportType.WebSockets })
            .withAutomaticReconnect()
            .build();

        connection.on('RecibirLoginCard', async (data) => {
            if (cancelled) return;

            // Validación 1: si la respuesta no es el objeto de usuario esperado
            // (string, mensaje "Error:", o sin token/usuario), la tarjeta no se
            // reconoció. Avisar al operario y no avanzar en el login.
            if (!isValidLoginResponse(data)) {
                setMensaje('La tarjeta no se reconoció');
                setTipoMensaje('error');
                setOpenSnack(true);
                return;
            }

            const currentCookie = new Cookies();
            if (!currentCookie.get('login')) {
                setOpenW(true);
                return;
            }

            // Validación 2: login exitoso. Resolver el nombre del usuario antes de
            // navegar y dejarlo listo para el saludo de bienvenida en el panel.
            let nombre = data.usuario;
            try {
                const info = await getUsuario(data.usuario, data.token);
                if (info?.nombre) nombre = info.nombre;
            } catch (error) {
                console.error('No se pudo obtener el nombre del usuario:', error);
            }
            if (cancelled) return;
            const safeName = String(nombre || '').trim();
            if (safeName) sessionStorage.setItem('welcomeUser', safeName);
            setToken(data);
        });

        connection.onreconnected(() => {
            connection.invoke('suscribirLoginCard', celdaId.toString()).catch(() => {});
        });

        connection.start()
            .then(() => {
                connection.invoke('suscribirLoginCard', celdaId.toString()).catch(() => {});
            })
            .catch(() => {});
        return () => {
            cancelled = true;
            connection.stop();
        };
    }, [setToken, getUsuario, setOpenW, setMensaje, setTipoMensaje, setOpenSnack]);

    return (
        <div className="login">
            <div className="login-wrapper">
                <div className={classes.root}>
                    <Collapse in={openC}>
                        <Alert
                            severity="error"
                            variant="filled"
                            action={
                                <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                        setOpenC(false);
                                    }}
                                >
                                    <CloseIcon fontSize="inherit" />
                                </IconButton>
                            }
                        >
                            No cuenta con los permisos para realizar esta acción!
                        </Alert>
                    </Collapse>
                </div>
                <div className={classes.root}>
                    <Collapse in={openA}>
                        <Alert
                            variant="filled"
                            severity="warning"
                            action={
                                <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                        setOpenA(false);
                                    }}
                                >
                                    <CloseIcon fontSize="inherit" />
                                </IconButton>
                            }
                        >
                            Debe seleccionar una linea!
                        </Alert>
                    </Collapse>
                </div>
                <div className={classes.root}>
                    <Collapse in={openB}>
                        <Alert
                            variant="filled"
                            severity="success"
                            action={
                                <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                        setOpenB(false);
                                    }}
                                >
                                    <CloseIcon fontSize="inherit" />
                                </IconButton>
                            }
                        >
                            Configuracion guardada correctamente!
                        </Alert>
                    </Collapse>
                </div>
                <div className={classes.root}>
                    <Collapse in={openW}>
                        <Alert
                            variant="filled"
                            severity="warning"
                            action={
                                <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                        setOpenW(false);
                                    }}
                                >
                                    <CloseIcon fontSize="inherit" />
                                </IconButton>
                            }
                        >
                            Configurar estación
                        </Alert>
                    </Collapse>
                </div>
                <div
                    className="login-wrapper-form"
                    style={{
                        display: configView ? 'none' : 'block',
                    }}
                >
                    <div
                        className="login-wrapper-form-titles"
                        style={{
                            display: isConfig ? 'none' : 'block',
                        }}
                    >
                        <img
                            src={LogoNova}
                            className="login-wrapper-form-titles-novalogo"
                            alt="tsr-logo"
                        />
                        <p className="login-wrapper-form-titles-title">{nombreL}</p>
                        <p className="login-wrapper-form-titles-celda">{nombreC}</p>
                        <p
                            style={{
                                display: process.env.REACT_APP_THEME === 'novaTheme' ? 'flex' : 'none',
                            }}
                        >
                            DEMO
                        </p>
                        <p className="login-wrapper-form-titles-subtitle">
                            Ingrese con sus credenciales o con su tarjeta de acceso
                        </p>
                    </div>
                    <div
                        className="login-wrapper-form-titles"
                        style={{
                            display: !isConfig ? 'none' : 'block',
                        }}
                    >
                        <img
                            src={LogoNova}
                            className="login-wrapper-form-titles-novalogo"
                            alt="tsr-logo"
                        />
                        
                        <p className="login-wrapper-form-titles-title">Panel de configuración</p>
                        <p className="login-wrapper-form-titles-subtitle">
                            Ingrese con sus credenciales o con su tarjeta de acceso
                        </p>
                    </div>
                    <div className="login-wrapper-form-inputs">
                        <form onSubmit={handleSubmit}>
                            <div className="login-wrapper-form-inputs-username-field">
                                <FormControl
                                    error={errorU}
                                    color="primary"
                                    className="login-username"
                                >
                                    <InputLabel
                                        className="login-wrapper-form-inputs-username-label"
                                        htmlFor="standard-adornment-username"
                                    >
                                        Nombre de usuario
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        id="standard-adornment-username"
                                        value={values.username}
                                        onChange={(e) => handleUserName(e.target.value)}
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <User></User>
                                            </InputAdornment>
                                        }
                                    />
                                    <FormHelperText className="error">
                                        {errorU ? 'Debe diligenciar el usuario' : ''}
                                    </FormHelperText>
                                </FormControl>
                            </div>
                            <div className="login-wrapper-form-inputs-username-field">
                                <FormControl
                                    className="login-password"
                                    color="primary"
                                    error={errorC}
                                >
                                    <InputLabel
                                        className="login-wrapper-form-inputs-username-label"
                                        htmlFor="standard-adornment-password"
                                    >
                                        Contraseña
                                    </InputLabel>
                                    <Input
                                        id="standard-adornment-password"
                                        type={values.showPassword ? 'text' : 'password'}
                                        value={values.password}
                                        onChange={handlePassChange}
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={handleClickShowPassword}
                                                    onMouseDown={handleMouseDownPassword}
                                                    size="small"
                                                >
                                                    {values.showPassword ? (
                                                        <Visibility />
                                                    ) : (
                                                        <VisibilityOff />
                                                    )}
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                    />
                                    <FormHelperText className="error">
                                        {errorC ? 'Debe diligenciar la contraseña' : ''}
                                    </FormHelperText>

                                    <FormHelperText className="error">
                                        {errorV ? 'usuario o contraseña invalido' : ''}
                                    </FormHelperText>
                                </FormControl>
                            </div>
                            <div
                                className="login-wrapper-form-inputs-button-field"
                                style={{
                                    display: isConfig ? 'none' : 'block',
                                }}
                            >
                                <Button
                                    type="submit"
                                    variant="contained"
                                    disabled={loading}
                                    className={buttonClassname}
                                    style={{
                                        width: '91%',
                                        height: '58px',
                                        textTransform: 'capitalize',
                                        fontSize: '22px',
                                    }}
                                    color="primary"
                                >
                                    Ingresar
                                </Button>
                                {loading && (
                                    <CircularProgress
                                        size={47}
                                        className={classes.buttonProgress}
                                    />
                                )}
                            </div>
                            <div
                                className="login-wrapper-form-inputs-button-field"
                                style={{
                                    display: !isConfig ? 'none' : 'block',
                                }}
                            >
                                <Button
                                    type="submit"
                                    variant="contained"
                                    disabled={loading}
                                    className={buttonClassname}
                                    style={{
                                        width: '91%',
                                        height: '58px',
                                        textTransform: 'capitalize',
                                        fontSize: '22px',
                                    }}
                                    color="primary"
                                >
                                    Abrir panel de configuración
                                </Button>
                                {loading && (
                                    <CircularProgress
                                        size={47}
                                        className={classes.buttonProgress}
                                    />
                                )}
                            </div>
                        </form>
                    </div>

                    <div
                        className="login-logo"
                        style={{
                            display: flag ? 'flex' : 'none',
                        }}
                    >
                        <div className="login-logo-companylogo">
                            <img
                                src={logo}
                                className="login-logo-complogo-img"
                                alt="company-logo"
                            />
                        </div>

                        <div className="login-logo-tsr-logo">
                            <img src={LogoTSR} className="login-logo-tsrlogo-img" alt="tsr-logo" />
                        </div>
                    </div>
                    <div
                        className="login-logo"
                        style={{
                            display: flag ? 'none' : 'flex',
                        }}
                    >
                        <div className="login-logo-otsrlogo">
                            <img src={LogoTSR} className="login-logo-otsrlogo-img" alt="tsr-logo" />
                        </div>
                    </div>
                    <div
                        className="login-wrapper-config"
                        style={{
                            display: isConfig ? 'none' : 'block',
                        }}
                    >
                        <Button
                            className="login-wrapper-config-button"
                            variant="contained"
                            onClick={() => setIsConfig(!isConfig)}
                        >
                            <Menu2 size={25} color={color} />
                            <div className="login-wrapper-config-button-text">Configuración</div>
                        </Button>
                    </div>
                    <div
                        className="login-wrapper-config"
                        style={{
                            display: !isConfig ? 'none' : 'block',
                        }}
                    >
                        <Button
                            className="login-wrapper-config-button"
                            variant="contained"
                            onClick={() => setIsConfig(!isConfig)}
                        >
                            <Logout size={25} color={color} />
                            <div className="login-wrapper-config-button-text">
                                Regresar a la página de ingreso
                            </div>
                        </Button>
                    </div>
                </div>
                <div
                    className="config-wrapper-form"
                    style={{
                        display: !configView ? 'none' : 'block',
                    }}
                >
                    <Config />
                </div>
                <div
                    className="login-wrapper-img"
                    style={{ display: isConfig ? 'none' : 'flex' }}
                >
                    <img src={loginImg} className="login-wrapper-img-size" alt="Card" />
                    <div className="login-wrapper-text">
                        <p className="config-wrapper-img-text">
                            <span className="config-wrapper-img-text-end">Ubique su</span> tarjeta
                            de acceso en el lector <span className="config-wrapper-img-text-end">para acceder directamente
                            </span>
                        </p>
                    </div>
                </div>
                <div
                    className="config-wrapper-img"
                    style={{ display: !isConfig ? 'none' : 'flex' }}
                >
                    <img src={config_img} className="config-wrapper-img-size" alt="config_img" />
                    <p className="config-wrapper-img-text">
                        Configuración de <span className="config-wrapper-img-text-end">celda</span>
                    </p>
                </div>
            </div>
            <ActionToast
                open={openSnack}
                message={mensaje}
                severity={tipoMensaje}
                onClose={() => setOpenSnack(false)}
            />
        </div>
    );
}

Login.propTypes = {
    setToken: PropTypes.func.isRequired,
};
